import React, { Component, useEffect, useRef, useState } from 'react';
import { connect } from 'react-redux';
import * as R from "ramda";
import { Route, Switch, Redirect, useLocation } from 'react-router';
import { useDispatch, useSelector } from 'react-redux';

import { fetchaAllPartnersInvoices, fetchAllClientsInvoices, fetchClientsInvoices, fetchPartnersInvoices } from '../../actions/backoffice/payments';
import * as LoadingsUser from '../../constants/loadings/user';
import * as LoadingsFacilita from '../../constants/loadings/facilita/deathDeclaration';
import { LoadingState } from '../../_common/loadingState';
import { ConfigurationHeader } from './_common/header';

import { ConfigurationGeneral } from './general';
import { ConfigurationServices } from './services';
import { getUserServiceData, getUserServiceDataDetails, getUserServices } from '../../actions/user-api';
import { getProductsPrices } from '../../actions/backoffice/configuration';

export const Configuration = () => {

	const dispatch = useDispatch();
	const userState = useSelector(state => state.user);
	const configState = useSelector(state => state.configurationReducer);



	useEffect(() => {

		dispatch(getProductsPrices());

	}, []);


	if (userState.isLoading.includes(LoadingsFacilita.FETCHING_USER_SERVICES_DATA || LoadingsUser.FETCH_SERVICES)) { return <LoadingState />; }
	//if (R.isNil(configState.services)) { return ''; }

	return (
		<article className="view-calc py-sm mb-auto">
			<ConfigurationHeader />
			<Switch>
				<Route exact path="/backoffice/configuration" >
					<ConfigurationGeneral configState={configState} />
				</Route>
				<Route path="/backoffice/configuration/services">
					<ConfigurationServices configState={configState} />
				</Route>
				<Route render={() => {
					return <Redirect exact to="/backoffice/configuration" configState={configState} />;
				}} />
			</Switch>
		</article>
	);

};

